import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { DynamicForm } from '../../../interfaces/dynamic-form';
import { FormParams } from '../../../interfaces/form-params';

@Component({
  selector: 'bm-text-form',
  templateUrl: './text-form.component.html',
  styleUrls: ['./text-form.component.scss']
})
export class TextFormComponent implements DynamicForm, OnInit {

  @HostBinding('class')
  @Input() className = '';

  @Input() params: FormParams;

  constructor() {}

  ngOnInit() {}

}
